import React from 'react';
import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { selectIncoming } from '../selectors';
import { GET_INCOMING_CARS, ORB_DOMAIN } from '../constants';
import { HBox, VBox } from '../../../components/Box';
import { Checkbox } from '../../../components/Checkbox';
import { Button } from '../../../components/Buttons';
import { FormField } from '../../../components/FormFields';
import { Input } from '../../../components/Input';
import { Modal, ModalControls } from '../../../components/Modal';
import { Dropdown } from '../../../components/Dropdown';
import { selectWorks } from '../../Api/selectors';
import { Cell, List, Row } from '../../../components/List';
import { Check, Times } from '../../../components/Icon';
import { Loader } from '../../../components/Loader';
import { legacyORBTransfer } from '../actions';
import { Well } from '../../../components/Well';
import { VehicleSelection } from '../../Vehicles/components/VehicleSelection';

const Container = styled.div``;

const STATE = {
  result: null,
  error: null,
  regplate: '',
  meldcode: '',
  mileage: '',
  mileage_unit: 'K',
  type: 'card',
  kentekendocumentnummer: '',
  tenaamstellingscodedeel1: '',
  tenaamstellingscodedeel2: '',
  controlergetal: '',
  duplicatecode: '',
};

/* eslint-disable react/prefer-stateless-function */
class LegacyTransferComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  reset() {
    this.props.onClose?.();
  }

  confirm() {
    this.props.confirm(
      {
        vehicleId: this.state.vehicle.id,
        regplate: this.state.regplate,
        meldcode: this.state.meldcode,
        type: this.state.type,
        duplicaatcode: this.state.duplicaatcode,
        controleletter: this.state.controleletter,
        kentekendocumentnummer: this.state.kentekendocumentnummer,
        tenaamstellingscodedeel1: this.state.tenaamstellingscodedeel1,
        tenaamstellingscodedeel2: this.state.tenaamstellingscodedeel2,
        nomileage: this.state.nomileage || false,
        mileage: this.state.mileage,
        mileage_unit: this.state.mileage_unit,
        request_mileage_report: this.state.request_mileage_report || false,
        wokblock: this.state.wokblock || false,
        request_kentekenkaart: this.state.request_kentekenkaart || false,
        kentekenkaart_overgedragen: this.state.kentekenkaart_overgedragen || false,
      },
      result => {
        if (!result.result) {
          this.setState({ result: false, error: result.data?.message, confirm: false });
        } else {
          let file = result.data.transactie.tellerrapportdocument;

          const dataURItoBlob = function(dataURI) {
            const byteString = window.atob(dataURI);
            const arrayBuffer = new ArrayBuffer(byteString.length);
            const int8Array = new Uint8Array(arrayBuffer);
            for (let i = 0; i < byteString.length; i++) {
              int8Array[i] = byteString.charCodeAt(i);
            }
            const blob = new Blob([int8Array], { type: 'application/pdf' });
            return blob;
          };

          // data should be your response data in base64 format

          const blob = dataURItoBlob(file);
          const url = URL.createObjectURL(blob);

          // to open the PDF in a new window
          window.open(url, '_blank');

          let objectUrl = URL.createObjectURL(blob);
          window.open(objectUrl);

          this.setState({ ...STATE, result: true, confirm: false });
        }
      },
    );
  }

  render() {
    return (
      <Container>
        <Modal onClose={this.reset.bind(this)} title="Vrijwaren">
          {this.renderBody()}
          <ModalControls>
            {this.props.loading || this.state.loading ? null : this.state.confirm ? (
              <>
                <Button primary onClick={this.confirm.bind(this)}>
                  {this.lbl('confirm')}
                </Button>
                <Button onClick={this.setStateFn({ confirm: false })}>{this.lbl('cancel')}</Button>
              </>
            ) : (
              <>
                <Button primary onClick={this.setStateFn({ confirm: true })}>
                  {this.lbl('confirm')}
                </Button>
                <Button onClick={this.reset.bind(this)}>{this.lbl('cancel')}</Button>
              </>
            )}
          </ModalControls>
        </Modal>
      </Container>
    );
  }

  renderBody() {
    if (this.state.loading || this.props.loading)
      return (
        <HBox center>
          <Loader />
        </HBox>
      );
    if (!this.state.vehicle) return this.renderSelectVehicle();
    if (this.state.confirm) return this.renderConfirmBody();
    if (this.state.result === true) return this.renderComplete();
    return (
      <>
        {this.state.result === false ? <Well alert>{this.state.error || 'error'}</Well> : null}
        <FormField label={this.lbl('vehicle.property.regplate')}>
          <input name="regplate" value={this.state.regplate} onChange={this.onInputChange.bind(this)} />
        </FormField>
        {this.state.type == 'paper' ? (
          <FormField label={this.lbl('vehicle.property.meldcode')}>
            <input name="meldcode" value={this.state.meldcode} onChange={this.onInputChange.bind(this)} />
          </FormField>
        ) : null}

        <FormField label={this.lbl('vehicle.property.mileage')}>
          <HBox vCenter left>
            <input name="mileage" value={this.state.mileage} onChange={this.onInputChange.bind(this)} />
            <Dropdown
              options={['K', 'M'].map(label => ({ label, value: label }))}
              value={this.state.mileage_unit}
              onChange={mileage_unit => this.setState({ mileage_unit: mileage_unit.value })}
            />
            <Checkbox checked={this.state.nomileage} onChange={this.setStateFn({ nomileage: !this.state.nomileage })}>
              {this.lbl('vehicle.property.orb.no-mileage')}
            </Checkbox>
          </HBox>
        </FormField>
        <Checkbox
          checked={this.state.request_mileage_report}
          onChange={this.setStateFn({ request_mileage_report: !this.state.request_mileage_report })}
        >
          {this.lbl('vehicle.property.orb.request_mileage_report')}
        </Checkbox>
        <FormField label={this.lbl('vehicle.property.orb.legacy.type')}>
          <Dropdown
            options={['paper', 'card'].map(label => ({
              label: this.lbl(`vehicle.property.orb.legacy.type.${label}`),
              value: label,
            }))}
            value={this.state.type}
            onChange={type => this.setState({ type: type.value })}
          />
        </FormField>

        <HBox>
          {(this.state.type == 'card'
            ? ['kentekendocumentnummer', 'tenaamstellingscodedeel1', 'tenaamstellingscodedeel2']
            : ['controlergetal', 'duplicatecode']
          ).map(name => (
            <FormField key={name} label={this.lbl('vehicle.property.orb.' + name)}>
              <Input name={name} value={this.state[name]} onChange={this.onInputChange.bind(this)} />
            </FormField>
          ))}
        </HBox>

        <VBox>
          <Checkbox checked={this.state.wokblock} onChange={this.setStateFn({ wokblock: !this.state.wokblock })}>
            {this.lbl('vehicle.property.orb.wokblock')}
          </Checkbox>

          <Checkbox
            checked={this.state.request_kentekenkaart}
            onChange={this.setStateFn({ request_kentekenkaart: !this.state.request_kentekenkaart })}
          >
            {this.lbl('vehicle.property.orb.request_kentekenkaart')}
          </Checkbox>

          <Checkbox
            checked={this.state.kentekenkaart_overgedragen}
            onChange={this.setStateFn({ kentekenkaart_overgedragen: !this.state.kentekenkaart_overgedragen })}
          >
            {this.lbl('vehicle.property.orb.kentekenkaart_overgedragen')}
          </Checkbox>
        </VBox>
      </>
    );
  }

  renderSelectVehicle() {
    return (
      <VehicleSelection
        onSelect={vehicle => {
          this.setState({ vehicle, regplate: vehicle.regplate, mileage: vehicle.mileage, meldcode: vehicle.meldcode });
        }}
      />
    );
  }

  renderConfirmBody() {
    return (
      <List>
        <Row>
          <Cell>{this.lbl('vehicle.property.regplate')}</Cell>
          <Cell>{this.state.regplate}</Cell>
        </Row>

        {this.state.type == 'paper' ? (
          <Row>
            <Cell>{this.lbl('vehicle.property.meldcode')}</Cell>
            <Cell>{this.state.meldcode}</Cell>
          </Row>
        ) : null}
        <Row>
          <Cell>{this.lbl('vehicle.property.mileage')}</Cell>
          <Cell>
            {this.state.mileage} {this.state.mileage_unit}
          </Cell>
        </Row>
        <Row>
          <Cell>{this.lbl('vehicle.property.orb.no-mileage')}</Cell>
          <Cell>{this.state.nomileage ? <Checkbox checked /> : <Times />}</Cell>
        </Row>
        <Row>
          <Cell>{this.lbl('vehicle.property.orb.request_mileage_report')}</Cell>
          <Cell>{this.state.request_mileage_report ? <Checkbox checked /> : <Times />}</Cell>
        </Row>
        {this.state.type == 'card' ? (
          <>
            <Row>
              <Cell>{this.lbl('kentekendocumentnummer')}</Cell>
              <Cell>{this.state.kentekendocumentnummer}</Cell>
            </Row>
            <Row>
              <Cell>{this.lbl('tenaamstellingscodedeel1')}</Cell>
              <Cell>{this.state.tenaamstellingscodedeel1}</Cell>
            </Row>
            <Row>
              <Cell>{this.lbl('tenaamstellingscodedeel2')}</Cell>
              <Cell>{this.state.tenaamstellingscodedeel2}</Cell>
            </Row>
          </>
        ) : (
          <>
            <Row>
              <Cell>{this.lbl('controlergetal')}</Cell>
              <Cell>{this.state.controlergetal}</Cell>
            </Row>
            <Row>
              <Cell>{this.lbl('duplicatecode')}</Cell>
              <Cell>{this.state.duplicatecode}</Cell>
            </Row>
          </>
        )}
        <Row>
          <Cell>{this.lbl('vehicle.property.orb.wokblock')}</Cell>
          <Cell>{this.state.wokblock ? <Checkbox checked /> : <Times />}</Cell>
        </Row>
        <Row>
          <Cell>{this.lbl('vehicle.property.orb.request_kentekenkaart')}</Cell>
          <Cell>{this.state.request_kentekenkaart ? <Checkbox checked /> : <Times />}</Cell>
        </Row>
        <Row>
          <Cell>{this.lbl('vehicle.property.orb.kentekenkaart_overgedragen')}</Cell>
          <Cell>{this.state.kentekenkaart_overgedragen ? <Checkbox checked /> : <Times />}</Cell>
        </Row>
      </List>
    );
  }

  renderComplete() {
    return (
      <Well success>
        <HBox center>
          <Check /> {this.lbl('complete')}
        </HBox>
      </Well>
    );
  }
}

LegacyTransferComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    loading: selectWorks([ORB_DOMAIN, GET_INCOMING_CARS]),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    confirm: (data, callback) => {
      dispatch(legacyORBTransfer(data, callback));
    },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const LegacyTransfer = compose(
  withRouter,
  withConnect,
)(LegacyTransferComp);
